import Vue from 'vue'
import VueRouter, { RouterOptions, RouteConfig } from 'vue-router'
import coreRoutes from '@rhitics/core/routes'

Vue.use(VueRouter)

export function createRouter(options: RouterOptions = { mode: 'history' }) {
  const { routes } = options
  const mergedRoutes = (routes as Array<RouteConfig>).concat(coreRoutes)
  const mergedOptions: RouterOptions = {
    ...options,
    mode: 'history',
    routes: mergedRoutes
  }

  const router = new VueRouter(mergedOptions);

    router.afterEach((to, from) => {
        Vue.nextTick(() => {
            document.title = to?.meta?.title || 'RHITICS';
        });
    });

  return router
}
